module.exports = __webpack_public_path__ + "static/media/ic-arrow-down.6d88f81f.svg";